import * as dialogTypes from '../constants/DialogActionTypes';
import _ from 'lodash'
import update from 'immutability-helper'

const initialState = {
  confirm: {
    open: false,
    confirmed:false,
    title: "",
    message: "",
    cancelText: "",
    confirmText: "",
  }
}

export default function dialogreducers(state=initialState,action={}) {
  
  switch (action.type) {
    case dialogTypes.CONFIRM_DIALOG_OPEN:
      return _.assign({},state,{
        confirm:{
          open: true,
          title: action.title,
          message: action.message,
          cancelText: action.cancelText,
          confirmText: action.confirmText,
          action: action.action,
        }
      })
    case dialogTypes.CONFIRM_DIALOG_CLOSE:
      return update(state,{
        confirm:{
          open: {
            $set: false
          },
          confirmed: {
            $set: false
          }
        }
      })
    case dialogTypes.CONFIRM_DIALOG_ACCEPT:
      return update(state,{
        confirm:{
          open: {
            $set: false
          },
          confirmed: {
            $set: true
          }
        }
      })
    default:
      return state
  }
}